import React from 'react';
import { CustomTextArea }
    from "Flow2/components/CustomCollections/CustomBox/CustomDataBox/CustomDataBox";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import StoreHelper from 'Flow2/components/Article/Helpers/StoreHelper';
import './TextArea.scss'

class TextArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customDataObjects: {}
        }
    }

    onTextAreaHandleChange = (name, event) => {
        try {
            const { value } = event.target;
            const { customDataObjects } = this.state;
            let tmpRows = name + 'rows';
            let currentRows = DataUtil.resizeTextArea(event);
            this.setState({ [tmpRows]: currentRows, [name]: value, customDataObjects: { ...customDataObjects, [name]: value } });
            if (this.props.freeType && this.props.updateCallback) {
                this.props.updateCallback(name, value);
            } else {
                StoreHelper.checkAndUpdateDataObj({
                    updateDataObjects: this.props.updateDataObjects,
                    mainObj: this.props.mainObj, subObjName: this.props.subObjName,
                    name: name, value: value
                });
            }
        } catch (error) {
            console.log("ERROR: onDateChange!");
        }
    };

    setUpSavedData = () => {
        const { current, item } = this.props;
        if (current) {
            const { customDataObjects } = this.state;
            this.setState({
                [`${item.name}`]: current,
                customDataObjects: { ...customDataObjects, [`${item.name}`]: current }
            });
        }

    }

    componentDidUpdate(prev) {
        if (prev.current != this.props.current) this.setUpSavedData();
    }

    componentDidMount() {
        this.setUpSavedData();
    }

    render() {
        const { item } = this.props;
        return (
            <div className="TextArea">
                <CustomTextArea key={item.key} fMsgId={item.intl} name={item.name}
                    mandatory={item.mandatory} requiredField={this.props.isRequired}
                    value={this.state.isDeleted ? "" : this.state.customDataObjects[item.name]}
                    onChange={this.onTextAreaHandleChange.bind(this, item.name)} lg={this.props.lg}
                    rows={this.state[item.name + 'rows']} id={item.name + 'areaTxtId'} />
            </div>)
    }
}



export default TextArea;